import React from 'react';

import { Flex, FlexProps, Image, Text } from '@mantine/core';
import logoDark from 'assets/images/logo_dark.png';
import logoLight from 'assets/images/logo_light.png';
import { useTranslation } from 'react-i18next';
import { ROUTE_LINKS } from 'shared/constants/route-links';

interface UpgradePlanLineProps extends FlexProps {
  showLogo?: boolean;
  dark?: boolean;
}

export function UpgradePlanLine({ showLogo = true, dark = true, ...flexProps }: UpgradePlanLineProps) {
  const { t } = useTranslation();

  return (
    <Flex direction="row" align="center" gap="xs" {...flexProps}>
      {showLogo && <Image width={15} src={dark ? logoDark : logoLight} />}
      <Text>
        {`${t('APP.NOT_AVAILABLE_AT_THIS_PLAN')}. `}
        <Text span component="a" href={ROUTE_LINKS.billing} style={{ textDecoration: 'underline' }}>
          {`${t('APP.ACTIONS.UPGRADE')}`}
        </Text>
      </Text>
    </Flex>
  );
}
